
import React from 'react';
import axios from 'axios';


import Image from 'react-bootstrap/Image';

import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { Link } from 'react-router-dom';


const appVars = AppVars.getInstance();

class AccountInactiveView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }


    render() {
        return(
            <div>
                 <div role = "banner">
                 <Link to = {appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota"/></Link>
                </div>
                 <div role = "main">
                        <div class="centered">
                            {/* <img src="assets/email.png"/> */}
                            <div className="title__TO" style = {{'marginTop' : '150px', 'marginBottom' : '30px'}}>Your account needs to be activated</div>    
                            <div className="message_TO">Click below and we'll resend your activation email.</div>    
                            <div className="subTitle__TO">{this.props.email}</div>
                            <div>
                                <Link to = {appVars.getResendActivationEmailURL(this.props.style)}><button id="reset" style = {{"marginTop" : "30px"}} className="button__TO">Resend Activation Email</button></Link>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }
}

export default AccountInactiveView;